"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("./styles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ProfileSummary({
  data
}) {
  const [selectedLanguage, setSelectedLanguage] = (0, _react.useState)('');
  const language = ({
    name,
    percent,
    color,
    usage,
    selected = name === selectedLanguage
  }) => /*#__PURE__*/_react.default.createElement(_styles.Language, {
    key: name,
    usage: percent,
    color: color,
    selected: selected,
    total: data.languages.length,
    "data-testid": `language-${name}`,
    "data-selected": selected,
    onClick: () => setSelectedLanguage(selected ? '' : name)
  }, name, /*#__PURE__*/_react.default.createElement("span", null, usage));
  if (data && Object.keys(data).length > 0 && data.user && data.stats && data.languages) {
    return /*#__PURE__*/_react.default.createElement(_styles.Container, {
      "data-testid": "profile-summary"
    }, /*#__PURE__*/_react.default.createElement(_styles.Box, null, /*#__PURE__*/_react.default.createElement("img", {
      src: data.user.avatar_url,
      alt: data.user.name
    }), /*#__PURE__*/_react.default.createElement(_styles.Resume, null, /*#__PURE__*/_react.default.createElement(_styles.Usage, null, data.languages.map(language)), /*#__PURE__*/_react.default.createElement(_styles.Stats, null, data.stats.map(stat => /*#__PURE__*/_react.default.createElement(_styles.Stat, {
      key: stat.key,
      "data-testid": `stat-${stat.key}`
    }, stat.title.replace(/<br ?\/>/gi, ' \n ').split('\n').map(string => /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: string
    }, string, /*#__PURE__*/_react.default.createElement("br", null))), /*#__PURE__*/_react.default.createElement("span", null, stat.value), stat.description))), /*#__PURE__*/_react.default.createElement(_styles.Link, {
      id: "see-profile",
      href: data.user.url,
      rel: "noopener noreferrer",
      target: "_blank",
      "data-testid": "login"
    }, data.user.login))));
  }
  return null;
}
ProfileSummary.propTypes = {
  data: _propTypes.default.oneOfType([_propTypes.default.shape({
    user: _propTypes.default.shape({
      name: _propTypes.default.string.isRequired,
      avatar_url: _propTypes.default.string.isRequired,
      login: _propTypes.default.string.isRequired,
      url: _propTypes.default.string.isRequired
    }).isRequired,
    languages: _propTypes.default.arrayOf(_propTypes.default.shape({
      name: _propTypes.default.string.isRequired,
      usage: _propTypes.default.string.isRequired,
      percent: _propTypes.default.number.isRequired,
      color: _propTypes.default.string.isRequired
    })),
    stats: _propTypes.default.arrayOf(_propTypes.default.shape({
      title: _propTypes.default.string.isRequired,
      value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
      description: _propTypes.default.string.isRequired
    })).isRequired
  }), _propTypes.default.bool]).isRequired
};
var _default = ProfileSummary;
exports.default = _default;